import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { SubscriptionDocument } from '@/lib/types/subscription'
import type { UpgradeSubscriptionRequest } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Upgrade subscription to a different plan
 * Simple version without Stripe - just updates the database
 */
export async function upgradeSubscription(
  request: UpgradeSubscriptionRequest,
): Promise<SubscriptionDocument> {
  const response = await AuthAxios.post<SubscriptionDocument>(
    `${ENDPOINT_SUBSCRIPTIONS}/upgrade`,
    request
  )
  return response.data
}
